module.exports = __webpack_public_path__ + "static/media/06.b1c731ad.jpg";